import { render } from "./ArchiveOutline.vue?vue&type=template&id=d89f5f7a"
import script from "./ArchiveOutline.vue?vue&type=script&lang=js"
export * from "./ArchiveOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__